import { useNavigate } from '@tanstack/react-router'
import { Eye } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { notifyError } from '@/components/notify'
import { useMe, useStopImpersonation } from '@/features/auth/api'

export function ImpersonationBanner() {
  const { data: me } = useMe()
  const stop = useStopImpersonation()
  const navigate = useNavigate()
  if (!me?.impersonating) return null
  return (
    <div role="status" className="relative z-30 flex items-center justify-center gap-3 bg-[repeating-linear-gradient(135deg,var(--warning)_0_14px,color-mix(in_oklch,var(--warning),black_8%)_14px_28px)] px-4 py-1.5 text-[13px] font-medium text-[oklch(0.25_0.05_70)]">
      <Eye className="size-4 shrink-0" />
      <span className="truncate">
        Impersonating <strong>{me.current_tenant?.name ?? 'tenant'}</strong> as {me.impersonating.by.name}. Actions are audited.
      </span>
      <Button
        size="sm"
        variant="outline"
        className="h-7 border-black/20 bg-white/70 text-[oklch(0.25_0.05_70)] hover:bg-white"
        loading={stop.isPending}
        onClick={() =>
          stop.mutate(undefined, {
            onSuccess: () => void navigate({ to: '/admin/tenants' }),
            onError: (e) => notifyError(e),
          })
        }
      >
        Stop impersonating
      </Button>
    </div>
  )
}
